<template>
    <div class="list-container">
        <h2>Manage Counselors</h2>
        <button class="btn btn-sm add-btn" @click="$router.push('/dashboard/counselors/add')">Add Counselor</button>

        <div v-if="loading" class="loading-overlay">
            <div class="spinner"></div>
        </div>

        <ul v-else class="data-list">
            <li v-for="counselor in counselors" :key="counselor.id" class="list-item "
                :class="{ 'bg-disabled': !counselor.user.is_active }">
                <div class="item-info">
                    <span class="info-item"><strong>Name:</strong> {{ counselor.user.name }}</span>
                    <span class="info-item"><strong>Email:</strong> {{ counselor.user.email }}</span>
                    <span class="info-item"><strong>Specialization:</strong> {{ counselor.specialization || 'N/A'
                        }}</span>
                    <span class="info-item"><strong>Active:</strong> {{ counselor.user.is_active ? 'Yes' : 'No'
                        }}</span>
                </div>
                <div class="btn-group">
                    <button class="btn btn-sm edit-btn"
                        @click="$router.push(`/dashboard/counselors/edit/${counselor.id}`)">✏️ Edit</button>
                    <button class="btn btn-sm delete-btn" @click="deleteCounselor(counselor.id)"
                        v-if="counselor.user.is_active">Disable</button>
                    <button class="btn btn-sm " @click="deleteCounselor(counselor.id)" v-else>
                        Enable</button>
                </div>
            </li>
        </ul>
    </div>
</template>



<script>

export default {
    data() {
        return {
            counselors: [],
            loading: false
        };
    },
    methods: {
        async fetchCounselors() {
            this.loading = true;
            try {
                const response = await this.$api.get('/counselors');
                this.counselors = response.data;

            } catch (error) {
                console.error("Error fetching counselors:", error);
            }
            this.loading = false;
        },
        async deleteCounselor(id) {
            if (!confirm("Are you sure you want to disable this counselor?")) return;
            try {
                let counselor = this.counselors.find(counselor => counselor.id == id);
                let c = { is_active: 1 - counselor.user.is_active };
                await this.$api.put(`/counselors/${id}`, c);
                counselor.user.is_active = c.is_active;

                // this.counselors = this.counselors.filter(counselor => counselor.id !== id);
            } catch (error) {
                console.error("Error deactivating counselor:", error);
            }
        }
    },
    mounted() {
        this.fetchCounselors();
    }
};
</script>

<style scoped>
.counselors-container {
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.7);
}

.spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-top: 4px solid #1DBCBC;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

ul.counselor-list {
    list-style: none;
    padding: 0;
    margin-top: 20px;
}

.counselor-list li {
    background: #f4f7fc;
    padding: 10px;
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 5px;
}

.btn-group {
    display: flex;
    gap: 10px;
}
</style>